import React from 'react';
import PropTypes from 'prop-types';

import Banner from '../Banner';

import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import ConfirmButton from '../ConfirmButton';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  button: {
    backgroundColor: 'white',
    color: 'black',
    marginLeft: 16,
  },
});

class ExistingLicenceBanner extends React.Component {

  componentDidMount() {
    this.props.fetchLicence();
  }

  componentWillReceiveProps({productId, userId, fetchLicence}) {
    if( productId !== this.props.productId 
        && userId !== this.props.userId ) {
      fetchLicence();
    }
  }

  render() {
    const {
      licence,
      revokeLicence,
      classes,
    } = this.props;
    if( licence && licence.owner ) {
      return (
        <Banner
          actions={[
            <ConfirmButton 
              className={classes.button}
              variant="contained"
              color="default"
              message={
                <FormattedMessage id='licence.revoke.confirmation' />
              }
              onClick={() =>
                revokeLicence(licence.subscriptionId)
              }
            >
              <FormattedMessage id='licence.revoke.button' />
            </ConfirmButton>
          ]}
        >
          <Typography>
            <FormattedMessage
              id="licence.existingLicence.banner"
              values={{
                ownerEmail: licence.owner.email
              }}
            />
          </Typography>
        </Banner>
      )
    }
    return null;
  }
}

ExistingLicenceBanner.propTypes = {
  licence: PropTypes.object,
  fetchLicence: PropTypes.func.isRequired,
  revokeLicence: PropTypes.func.isRequired,
  productId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
}

export default withStyles(styles)(ExistingLicenceBanner);
  



// WEBPACK FOOTER //
// ./src/components/products/ExistingLicenceBanner.js